import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Esto desplazará la página a la parte superior cuando cambie la ruta
  }, [location]);

  return null; // No renderiza nada, solo maneja el desplazamiento
}

export default ScrollToTop;
